import * as React from "react"
import { Route, Routes, useParams } from "react-router-dom"

import { StatefulFieldRemountProvider } from "Catalog/shared/components/StatefulFieldRemountContext"
import { UIPreferencesProvider } from "Catalog/shared/components/UIPreferencesContext"
import { useConfig } from "shared/components/ConfigContext"
import { EditorContextProvider } from "shared/components/EditorContext"
import PageError from "shared/components/PageError"
import PageSpinner from "shared/components/PageSpinner"
import { useAccountQuery } from "shared/hooks/queries"
import { routeConfigs } from "shared/utils/routes"

import { namedRoutes as editRoutes } from "./Edit/routes"
import { namedRoutes as gridRoutes } from "./Grid/routes"
import { namedRoutes as previewRoutes } from "./Preview/routes"

const Preview = (): JSX.Element => {
  const { appInstanceId } = useConfig()
  const { catalogId } = useParams<{ catalogId: string }>()

  const { data: account } = useAccountQuery(appInstanceId)

  if (!account) return <PageSpinner />

  return (
    <StatefulFieldRemountProvider>
      <UIPreferencesProvider>
        <EditorContextProvider catalogId={catalogId!} currency={account.currency}>
          <Routes>
            {routeConfigs(editRoutes, gridRoutes, previewRoutes).map(({ pathTemplate, element }, index) => {
              return <Route path={pathTemplate} element={element} key={index} />
            })}

            <Route path="*" element={<PageError error={"Page not found"} />} />
          </Routes>
        </EditorContextProvider>
      </UIPreferencesProvider>
    </StatefulFieldRemountProvider>
  )
}

export default Preview
